import { render } from "./SelectTTPPGabung.vue?vue&type=template&id=3b52bb16"
import script from "./SelectTTPPGabung.vue?vue&type=script&lang=js"
export * from "./SelectTTPPGabung.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__